import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { actionCreators as toastAlertsCreators } from 'react/api/actions/toastAlerts';

import { connect } from 'react-redux';

const BaseToast = ({
  toastId,
  header,
  body,
  footer,
  removeToast,
  ...rest
}) => {
  const toastContainerRef = useRef(null);
  const mainTimerRef = useRef(null);
  const secondaryTimerRef = useRef(null);

  function clearTimeouts() {
    clearTimeout(mainTimerRef.current);
    clearTimeout(secondaryTimerRef.current);
  }

  function removeThisToast() {
    removeToast({ id: toastId });
  }

  function initTimeout() {
    if (mainTimerRef.current) {
      clearTimeouts();

      toastContainerRef.current.classList.remove('animation_trigger');
    }

    mainTimerRef.current = setTimeout(() => {
      toastContainerRef.current.classList.add('animation_trigger');

      secondaryTimerRef.current = setTimeout(() => {
        removeThisToast();
      }, 1000);
    }, 7000);
  }

  useEffect(() => {
    initTimeout();

    return () => {
      clearTimeouts();
    };
  }, []);

  return (
    <div
      id="toast-container"
      ref={toastContainerRef}
      onMouseMove={initTimeout}
      {...rest}
    >
      <div className="toast-title">
        {header}
      </div>
      <div className="toast-body">
        {body}
      </div>
      {footer && (
        <div className="toast-footer">
          {footer}
        </div>
      )}
    </div>
  );
};

BaseToast.propTypes = {
  toastId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  header: PropTypes.element.isRequired,
  body: PropTypes.element.isRequired,
  footer: PropTypes.element,
  removeToast: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  removeToast: toastAlertsCreators.removeToast,
};

export default connect(null, mapDispatchToProps)(BaseToast);
